/* eslint-disable react/prop-types */
import React from 'react';
import MdIcon from '~/shared/components/mdIcon';

import { Blur } from './styles';

const BlurCard = ({ children, active }) => {
  return <Blur isBlurred={active}>{children}</Blur>;
};

export default BlurCard;
